import React from "react";
import classnames from "classnames";
import Checkbox from "@mui/material/Checkbox";

// App-wide checkbox — a single, consistent look (MUI default icon at 20px,
// accent-blue when checked) shared across the DealPage, Default Settings, etc.
// The visual styling lives in the `app-checkbox` SCSS mixin (applied globally to
// `.app-checkbox`); this wrapper just guarantees every checkbox carries the class.
export const AppCheckbox = ({ className, ...props }) => (
    <Checkbox className={classnames('app-checkbox', className)} {...props}/>
)
